import { render, staticRenderFns } from "./PivotProp.vue?vue&type=template&id=3651de48&"
import script from "./PivotProp.vue?vue&type=script&lang=js&"
export * from "./PivotProp.vue?vue&type=script&lang=js&"
import style0 from "./PivotProp.vue?vue&type=style&index=0&id=3651de48&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports